import { Message } from "@/types/chat";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef } from "react";
import { ChatMessage } from "./ChatMessage";
import { LoadingMessage } from "./LoadingMessage";

interface ChatMessageListProps {
  messages: Message[];
  isLoading?: boolean;
}

export function ChatMessageList({ messages, isLoading }: ChatMessageListProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const uniqueMessages = messages.filter((message, index, self) =>
    index === self.findIndex((m) => 
      m.content === message.content && 
      m.created_at === message.created_at
    )
  );

  return (
    <>
      <AnimatePresence mode="popLayout">
        {uniqueMessages.map((message) => (
          <ChatMessage key={message.id} message={message} />
        ))}
        {isLoading && <LoadingMessage />}
      </AnimatePresence>
      <div ref={scrollRef} className="h-4" />
    </>
  );
}